import { Link } from "react-router-dom";
import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  display: flex;
  margin: 20px;
  flex-direction: column;
`

export const SignUpButton = styled.button`
  align-self: center;
  height: 100px;
  width: 660px;
  background-color: #FD8706;
  border-style: solid;
  border-width: 2px;
  border-color: black;
  font-size: 20px;
  margin: 30px;
  justify-content: center;
  align-self: center;
  box-shadow: 5px 5px 10px 2px rgba(0,0,0,.8);
`
export const Title = styled.h2`
  font-size: 50px;
  text-align: initial;
  margin-left: 15px;
`
export const Description = styled.h3`
  margin-left: 15px;
  font-size: 18px;
  text-align: initial;
`
export const ServicesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
`
export const LinkItem = styled(Link)``
